import './ChordTypeHelper.scss'
import { Capitalize } from '../../Util/Strings/Capitalize'
import { TransformTranslate } from '../../Util/Transform/Transform'
import { HexMap } from '../../Data/HexMap/HexMap'
import { BuildHexMap } from '../../Data/HexMap/HexMapBuilder'
import { Music } from '../../Util/Music/Music'
import { Note } from '../../Data/HexMap/Note'
import { HxMapGroup } from '../HxMap/HxMapGroup'

export function ChordTypeHelper(props:{width?:number, height?:number, selectedPosition?:number, radius?:number}){
    const radius:number = (props.radius) ? props.radius : 50
    const height:number = (props.height) ? props.height : 150
    const width:number = (props.width) ? props.width : 150
    const getChordType = (noteData:Note) => {
        let type:string = getChordTypeFull(noteData.params.noteIndex)
        return type.split('').splice(0,3).join('').toLowerCase()
    }
    const getChordTypeFull = (noteIndex:number) => {
        if([0,3,4].includes(noteIndex)){return 'Major'}
        if([1,2,5].includes(noteIndex)){return 'Minor'}
        return 'Diminished'        
    }
    let mapData:HexMap = BuildHexMap({columns:1, rows:1, tonic:Music.G, radius:radius})
    mapData.notes.forEach((note:Note)=>{
        //note.defined = false
        const chordType:string = getChordType(note)
        note.primaryLabel = Capitalize(chordType)
        note.classNames.push(chordType)
    })
/*     const getLine = () => {
        //return null
        const radius:number = keys[0].radius
        const h:number = 2
        const w:number = (radius * 2 * .866)
        const xTranslate:number = (radius * 2 * .866) - (h * 2)
        const yTranslate:number = radius * .59
        const transform:string = TransformTranslate(xTranslate, yTranslate) + ' rotate(120)'
        return <rect className='dividing-line' height={h} width={w} transform={transform}/>
    } */
    const Caption = () => {
        const getCaptionText = () => {
            if(props.selectedPosition === undefined) return null
            const chordNumber:number = props.selectedPosition + 1
            return 'The ' + chordNumber + ' chord is ' + getChordTypeFull(props.selectedPosition)
        }
        return(
            <g className='caption' transform={TransformTranslate(0,radius * 3.3)}>
                <text><tspan>{getCaptionText()}</tspan></text>
            </g>
        )
    }
    return(
        <div>
            <svg width={width} height={height} className={'hex-parent chord-type-helper'}>
                <g transform={TransformTranslate(width/2,height/2)}><HxMapGroup hexMap={mapData}/></g>
            </svg>
        </div>
    )
}